import { STORAGE_LIMITS } from '@/constants/constants'
import type { UserState } from '@/types/state'

const initialState: UserState = {
  storageLimits: STORAGE_LIMITS,
  permissions: null,
}

export default initialState
